import HelpCenterIcon from "../icons/BurgerMenuIcons/HelpCenterIcon.svg?react";
import SubmitTagsIcon from "../icons/BurgerMenuIcons/SubmitTagsIcon.svg?react";
import GuidelinesIcon from "../icons/BurgerMenuIcons/GuidelinesIcon.svg?react";
import FAQIcon from "../icons/BurgerMenuIcons/FAQIcon.svg?react";
import TermsIcon from "../icons/BurgerMenuIcons/TermsIcon.svg?react";
import PrivacyIcon from "../icons/BurgerMenuIcons/PrivacyIcon.svg?react";
import DMCAIcon from "../icons/BurgerMenuIcons/DMCAIcon.svg?react";
import StatementIcon from "../icons/BurgerMenuIcons/StatementIcon.svg?react";
import RGCams from "../icons/BurgerMenuIcons/RGCams.svg?react";

const BurgerMenuIcons = {
  HelpCenterIcon,
  SubmitTagsIcon,
  GuidelinesIcon,
  FAQIcon,
  TermsIcon,
  PrivacyIcon,
  DMCAIcon,
  StatementIcon,
  RGCams
};

export default BurgerMenuIcons;
